/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Message = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        from: {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        name: {
    type: 'string',
    isRequired: true,
},
    },
    isRequired: true,
},
        group: {
    type: 'number',
},
        companyId: {
    type: 'number',
    isRequired: true,
},
        message: {
    type: 'string',
},
        media: {
    type: 'string',
    isRequired: true,
},
        sentAt: {
    type: 'string',
},
        readAt: {
    type: 'string',
},
    },
};